// import {
//   Button,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   FormLabel,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
// import React, { useState } from "react";
// import { brands } from "../../../data/Filter/brand";
// import { teal } from "@mui/material/colors";
// import zIndex from "@mui/material/styles/zIndex";
// import { size } from "../../../data/Filter/size";
// import { colors } from "../../../data/Filter/color";
// import { price } from "../../../data/Filter/price";
// import { discount } from "../../../data/Filter/discount";
// import { useSearchParams } from "react-router-dom";

// const FilterSection = () => {
//   const [expendColor, setExpendColor] = useState(false);
//   const [expendBrand, setExpendBrand] = useState(false);
//   const [expendSize, setExpendSize] = useState(false);

//   const [searchParams, setSearchParams] = useSearchParams();

//   const handleExpendBrand = () => {
//     setExpendBrand(!expendBrand);
//   };
//   const handleExpendColor = () => {
//     setExpendColor(!expendColor);
//   };

//   const handleExpendSize = () => {
//     setExpendColor(!expendColor);
//   };

//   const updateFilterParams = (e: any) => {
//     const { value, name } = e.target;
//     if (value) {
//       searchParams.set(name, value);
//     } else {
//       searchParams.delete(name);
//     }
//     setSearchParams(searchParams);
//   };

//   const clearAllFilters = () => {
//     console.log("clearAllFilters",searchParams)
//     searchParams.forEach((value: any, key: any) => {
//       searchParams.delete(key);
//     });
//     setSearchParams(searchParams);
//   };

//   return (
//     <div className="-z-50 space-y-5 bg-white">
//       <div className="flex items-center justify-between h-[40px] px-9 lg:border-r">
//         <p className="text-lg font-semibold">Filters</p>
//         <Button
//         onClick={clearAllFilters}
//           size="small"
//           className="text-teal-600 cursor-pointer font-semibold"
//         >
//           clear all
//         </Button>
//       </div>
//       <Divider />
//       <div className="px-9 space-y-6">
//         {/* <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="brand"
//             >
//               Brand
//             </FormLabel>
//             <RadioGroup
//               onChange={updateFilterParams}
//               aria-labelledby="brand"
//               defaultValue=""
//               name="brand"
//             >
//               {brands
//                 .slice(0, expendBrand ? brands.length : 5)
//                 .map((item, index) => (
//                   <FormControlLabel
//                     key={item.name}
//                     value={item.value}
//                     control={<Radio size="small" />}
//                     label={item.name}
//                   />
//                 ))}
//             </RadioGroup>
//           </FormControl>
//           <div>
//             <button
//               onClick={handleExpendBrand}
//               className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
//             >
//               {expendBrand ? "hide" : `+ ${brands.length - 5} more`}
//             </button>
//           </div>
//         </section>
//         <Divider /> */}

//           {/* Size */}
//           <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="brand"
//             >
//               Size
//             </FormLabel>
//             <RadioGroup
//               name="size"
//               onChange={updateFilterParams}
//               aria-labelledby="brand"
//               defaultValue=""
//             >
//               {size.map((item, index) => (
//                 <FormControlLabel
//                   key={item.name}
//                   value={item.value}
//                   control={<Radio size="small" />}
//                   label={item.name}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </section>


//         {/* // Color */}
//         <section>
//           <FormControl sx={{ zIndex: 0 }}>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="color"
//             >
//               Color
//             </FormLabel>
//             <RadioGroup
//               onChange={updateFilterParams}
//               aria-labelledby="color"
//               defaultValue=""
//               name="color"
//             >
//               {colors
//                 .slice(0, expendColor ? colors.length : 5)
//                 .map((item, index) => (
//                   <FormControlLabel
//                     sx={{ fontSize: "12px" }}
//                     key={item.name}
//                     value={item.name}
//                     control={<Radio size="small" />}
//                     label={
//                       <div className="flex items-center gap-3">
//                         <p>{item.name}</p>
//                         <span
//                           style={{ backgroundColor: item.hex }}
//                           className={` h-5 w-5 rounded-full ${
//                             item.name === "White" ? "border" : "border"
//                           }`}
//                         ></span>
//                       </div>
//                     }
//                   />
//                 ))}
//             </RadioGroup>
//           </FormControl>
//           <div>
//             <button
//               onClick={handleExpendColor}
//               className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
//             >
//               {expendColor ? "hide" : `+ ${colors.length - 5} more`}
//             </button>
//           </div>
//         </section>
//         <Divider />

//         <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="price"
//             >
//               Price
//             </FormLabel>
//             <RadioGroup
//               name="price"
//               onChange={updateFilterParams}
//               aria-labelledby="price"
//               defaultValue=""
//             >
//               {price.map((item, index) => (
//                 <FormControlLabel
//                   key={item.name}
//                   value={item.value}
//                   control={<Radio size="small" />}
//                   label={item.name}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </section>
//         <Divider />
//         <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="brand"
//             >
//               Discount
//             </FormLabel>
//             <RadioGroup
//               name="discount"
//               onChange={updateFilterParams}
//               aria-labelledby="brand"
//               defaultValue=""
//             >
//               {discount.map((item, index) => (
//                 <FormControlLabel
//                   key={item.name}
//                   value={item.value}
//                   control={<Radio size="small" />}
//                   label={item.name}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default FilterSection;


// UPDATING AACTUQL CODE

import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useState } from "react";
import { brands } from "../../../data/Filter/brand";
import { teal } from "@mui/material/colors";
import zIndex from "@mui/material/styles/zIndex";
import { size } from "../../../data/Filter/size";
import { colors } from "../../../data/Filter/color";
import { price } from "../../../data/Filter/price";
import { discount } from "../../../data/Filter/discount";
import { useSearchParams } from "react-router-dom";

const FilterSection = () => {
  const [expendColor, setExpendColor] = useState(false);
  const [expendBrand, setExpendBrand] = useState(false);
  const [expendSize, setExpendSize] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const handleExpendBrand = () => {
    setExpendBrand(!expendBrand);
  };
  const handleExpendColor = () => {
    setExpendColor(!expendColor);
  };

  const handleExpendSize = () => {
    setExpendColor(!expendColor);
  };

  const updateFilterParams = (e: any) => {
    const { value, name } = e.target;
    if (value) {
      searchParams.set(name, value);
    } else {
      searchParams.delete(name);
    }
    setSearchParams(searchParams);
  };

  const clearAllFilters = () => {
    console.log("clearAllFilters",searchParams)
    searchParams.forEach((value: any, key: any) => {
      searchParams.delete(key);
    });
    setSearchParams(searchParams);
  };

  return (
    <div className="-z-50 space-y-5 bg-white">
      <div className="flex items-center justify-between h-[40px] px-9 lg:border-r">
        <p className="text-lg font-semibold">Filters</p>
        <Button
        onClick={clearAllFilters}
          size="small"
          className="text-teal-600 cursor-pointer font-semibold"
        >
          clear all
        </Button>
      </div>
      <Divider />
      <div className="px-9 space-y-6">
        {/* <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="brand"
            >
              Brand
            </FormLabel>
            <RadioGroup
              onChange={updateFilterParams}
              aria-labelledby="brand"
              defaultValue=""
              name="brand"
            >
              {brands
                .slice(0, expendBrand ? brands.length : 5)
                .map((item, index) => (
                  <FormControlLabel
                    key={item.name}
                    value={item.value}
                    control={<Radio size="small" />}
                    label={item.name}
                  />
                ))}
            </RadioGroup>
          </FormControl>
          <div>
            <button
              onClick={handleExpendBrand}
              className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
            >
              {expendBrand ? "hide" : `+ ${brands.length - 5} more`}
            </button>
          </div>
        </section>
        <Divider /> */}

          {/* Size */}
          <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="size"
            >
              Size
            </FormLabel>
            <RadioGroup
              name="size"
              onChange={updateFilterParams}
              aria-labelledby="size"
              defaultValue=""
            >
              {size.map((item, index) => (
                <FormControlLabel
                  key={item.name}
                  value={item.value}
                  control={<Radio size="small" />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </section>



        {/* // Color */}
        <section>
          <FormControl sx={{ zIndex: 0 }}>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="color"
            >
              Color
            </FormLabel>
            <RadioGroup
              onChange={updateFilterParams}
              aria-labelledby="color"
              defaultValue=""
              name="color"
            >
              {colors
                .slice(0, expendColor ? colors.length : 5)
                .map((item, index) => (
                  <FormControlLabel
                    sx={{ fontSize: "12px" }}
                    key={item.name}
                    value={item.name}
                    control={<Radio size="small" />}
                    label={
                      <div className="flex items-center gap-3">
                        <p>{item.name}</p>
                        <span
                          style={{ backgroundColor: item.hex }}
                          className={` h-5 w-5 rounded-full ${
                            item.name === "White" ? "border" : "border"
                          }`}
                        ></span>
                      </div>
                    }
                  />
                ))}
            </RadioGroup>
          </FormControl>
          <div>
            <button
              onClick={handleExpendColor}
              className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
            >
              {expendColor ? "hide" : `+ ${colors.length - 5} more`}
            </button>
          </div>
        </section>
        <Divider />

        <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="price"
            >
              Price
            </FormLabel>
            <RadioGroup
              name="price"
              onChange={updateFilterParams}
              aria-labelledby="price"
              defaultValue=""
            >
              {price.map((item, index) => (
                <FormControlLabel
                  key={item.name}
                  value={item.value}
                  control={<Radio size="small" />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </section>
        <Divider />
        <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                pb: "14px",
                color: teal[600],
              }}
              className="text-2xl font-semibold"
              id="brand"
            >
              Discount
            </FormLabel>
            <RadioGroup
              name="discount"
              onChange={updateFilterParams}
              aria-labelledby="brand"
              defaultValue=""
            >
              {discount.map((item, index) => (
                <FormControlLabel
                  key={item.name}
                  value={item.value}
                  control={<Radio size="small" />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </section>
      </div>
    </div>
  );
};

export default FilterSection;





// code change to check filter section for size

// import {
//   Button,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   FormLabel,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
// import React, { useState } from "react";
// import { size } from "../../../data/Filter/size";
// import { teal } from "@mui/material/colors";
// import zIndex from "@mui/material/styles/zIndex";
// import { colors } from "../../../data/Filter/color";
// import { price } from "../../../data/Filter/price";
// import { discount } from "../../../data/Filter/discount";
// import { useSearchParams } from "react-router-dom";

// const FilterSection = () => {
//   const [expendColor, setExpendColor] = useState(false);
//   const [expendBrand, setExpendBrand] = useState(false);
//   const [expendSize, setExpendSize] = useState(false);

//   const [searchParams, setSearchParams] = useSearchParams();

//   const handleExpendBrand = () => {
//     setExpendBrand(!expendBrand);
//   };
//   const handleExpendColor = () => {
//     setExpendColor(!expendColor);
//   };
//   const handleExpendSize = () => {
//     setExpendColor(!expendColor);
//   };

//   const updateFilterParams = (e: any) => {
//     const { value, name } = e.target;
//     if (value) {
//       searchParams.set(name, value);
//     } else {
//       searchParams.delete(name);
//     }
//     setSearchParams(searchParams);
//   };

//   // const clearAllFilters = () => {
//   //   console.log("clearAllFilters",searchParams)
//   //   searchParams.forEach((value: any, key: any) => {
//   //     searchParams.delete(key);
//   //   });
//   //   setSearchParams(searchParams);
//   // };
//     const clearAllFilters = () => {
//     setSearchParams({});
//   };

//   return (
//     <div className="-z-50 space-y-5 bg-white">
//       <div className="flex items-center justify-between h-[40px] px-9 lg:border-r">
//         <p className="text-lg font-semibold">Filters</p>
//         <Button
//         onClick={clearAllFilters}
//           size="small"
//           className="text-teal-600 cursor-pointer font-semibold"
//         >
//           clear all
//         </Button>
//       </div>
//       <Divider />
//       <div className="px-9 space-y-6">
//         <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="size"
//             >
//               Size
//             </FormLabel>
//             <RadioGroup
//               onChange={updateFilterParams}
//               aria-labelledby="size"
//               defaultValue=""
//               name="size"
//             >
//               {size
//                 .slice(0, expendSize ? size.length : 5)
//                 .map((item, index) => (
//                   <FormControlLabel
//                     key={item.name}
//                     value={item.value}
//                     control={<Radio size="small" />}
//                     label={item.name}
//                   />
//                 ))}
//             </RadioGroup>
//           </FormControl>
//           <div>
//             <button
//               onClick={handleExpendSize}
//               className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
//             >
//               {expendSize ? "Hide" : `+ ${size.length - 5} more`}
//             </button>
//           </div>
//         </section>
//         <Divider />
//         <section>
//           <FormControl sx={{ zIndex: 0 }}>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="color"
//             >
//               Color
//             </FormLabel>
//             <RadioGroup
//               onChange={updateFilterParams}
//               aria-labelledby="color"
//               defaultValue=""
//               name="color"
//             >
//               {colors
//                 .slice(0, expendColor ? colors.length : 5)
//                 .map((item, index) => (
//                   <FormControlLabel
//                     sx={{ fontSize: "12px" }}
//                     key={item.name}
//                     value={item.name}
//                     control={<Radio size="small" />}
//                     label={
//                       <div className="flex items-center gap-3">
//                         <p>{item.name}</p>
//                         <span
//                           style={{ backgroundColor: item.hex }}
//                           className={` h-5 w-5 rounded-full ${
//                             item.name === "White" ? "border" : "border"
//                           }`}
//                         ></span>
//                       </div>
//                     }
//                   />
//                 ))}
//             </RadioGroup>
//           </FormControl>
//           <div>
//             <button
//               onClick={handleExpendColor}
//               className="text-teal-600 cursor-pointer hover:text-teal-900 flex items-center"
//             >
//               {expendColor ? "Hide" : `+ ${colors.length - 5} more`}
//             </button>
//           </div>
//         </section>
//         <Divider />

//         <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="price"
//             >
//               Price
//             </FormLabel>
//             <RadioGroup
//               name="price"
//               onChange={updateFilterParams}
//               aria-labelledby="price"
//               defaultValue=""
//             >
//               {price.map((item, index) => (
//                 <FormControlLabel
//                   key={item.name}
//                   value={item.value}
//                   control={<Radio size="small" />}
//                   label={item.name}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </section>
//         <Divider />
//         <section>
//           <FormControl>
//             <FormLabel
//               sx={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 pb: "14px",
//                 color: teal[600],
//               }}
//               className="text-2xl font-semibold"
//               id="size"
//             >
//               Discount
//             </FormLabel>
//             <RadioGroup
//               name="discount"
//               onChange={updateFilterParams}
//               aria-labelledby="size"
//               defaultValue=""
//             >
//               {discount.map((item, index) => (
//                 <FormControlLabel
//                   key={item.name}
//                   value={item.value}
//                   control={<Radio size="small" />}
//                   label={item.name}
//                 />
//               ))}
//             </RadioGroup>
//           </FormControl>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default FilterSection;
